import { apiClient } from "lib/apiClient";

export const deleteDeals = async (request: string[], urlEnding = "") => {
  const response = await apiClient.delete(`/deals${urlEnding}`, {
    data: request,
  });

  return response.data;
};
